<template>
    <v-dialog
        v-model="viewWhy"
        scrollable
        persistent
        max-width="1300px"
    >
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                Why Not Match
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('closeWNM')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-card>
                    <v-toolbar dense>
                        Order Qualifications
                    </v-toolbar>
                </v-card>
                <v-container grid-list-xs>
                    <v-simple-table dense v-for="required in dataWhy.requirementOrders">
                        <thead>
                            <tr>
                                <th class="text-center">OrderID</th>
                                <th class="text-center" colspan="3">Terminal</th>
                                <th class="text-center" colspan="2">Station</th>
                                <th class="text-center" colspan="1">Region</th>
                                <th class="text-center" v-if="required.PumpCall">PumpCall</th>
                                <th class="text-center" v-if="required.QuadCall">QuadCall</th>
                                <th class="text-center" v-if="required.StraitTruck">Strait</th>
                                <th class="text-center" v-if="required.isSpecific">Specific Product</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ required.OrderID }}</td>
                                <td colspan="3">{{ required.Terminal }}</td>
                                <td colspan="2">{{ required.Station }}</td>
                                <td class="text-center" colspan="1">{{ required.PrincipalRegion }}</td>
                                <td v-if="required.PumpCall"><v-icon color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="required.QuadCall"><v-icon color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="required.StraitTruck"><v-icon color="success">mdi-check-circle-outline</v-icon></td>
                                <td class="text-center" v-if="required.isSpecific"><v-icon color="success">mdi-check-circle-outline</v-icon></td>
                            </tr>
                                <tr>
                                    <th class="text-center" >ShiftDetail</th>
                                    <th class="text-center">Driver</th>
                                    <th class="text-center">Truck</th>
                                    <th class="text-center">Trailer</th>
                                    <th class="text-center">Yard</th>
                                    <th class="text-center" >Distance Station - Terminal</th>
                                    <th class="text-center" >Distance Yard</th>
                                    <th class="text-center" colspan="1">Region</th>
                                    <th class="text-center">Load Bagde</th>
                                    <th class="text-center" v-if="required.IsTerminal">Off Load Bagde</th>
                                    <th class="text-center" v-if="required.PumpCall">PumpCall</th>
                                    <th class="text-center" v-if="required.QuadCall">QuadCall</th>
                                    <th class="text-center" v-if="required.StraitTruck">Strait</th>
                                    <th class="text-center" v-if="required.isSpecific">Specific Product</th>
                                </tr>
                            
                                <tr v-for="ql in dataWhy.Qualification">
                                    <td class="text-center">{{ ql.ShiftDetail }}</td>
                                    <td class="text-center">{{ ql.Driver }}</td>
                                    <td class="text-center">{{ ql.Truck }}</td>
                                    <td class="text-center">{{ ql.Trailer }}</td>
                                    <td class="text-center">{{ ql.Yard }}</td>
                                    <td class="text-center">{{ ql.distance_in_kilometers_yard_end }}</td>
                                    <td class="text-center">{{ ql.distance_in_kilometers_station_terminal }}</td>
                                    <td class="text-center" ><v-icon :color="ql.PrincipalRegion == required.Region ? 'success':'red'" >{{ ql.PrincipalRegion ==  required.Region ? 'mdi-check-circle-outline' :'mdi-close-circle'  }}</v-icon></td>
                                    <td class="text-center"><v-icon :color="ql.LoadCarding == true ? 'success':'red'" >{{ ql.LoadCarding == true ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                    <td class="text-center" v-if="required.IsTerminal"><v-icon :color="ql.UnLoadCarding == true ? 'success':'red'" >{{ ql.UnLoadCarding == true ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                    <td class="text-center" v-if="required.PumpCall"><v-icon :color="ql.PumpCall == true ? 'success':'red'" >{{ ql.PumpCall == true ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                    <td class="text-center" v-if="required.QuadCall"><v-icon :color="ql.QuadCall == true ? 'success':'red'" >{{ ql.QuadCall == true ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                    <td class="text-center" v-if="required.StraitTruck"><v-icon :color="ql.StraitTruck == true ? 'success':'red'" >{{ ql.StraitTruck == true ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                    <td class="text-center" v-if="required.isSpecific"><v-icon :color="ql.IsSpecificProduct == 1 ? 'success':'red'" >{{ ql.IsSpecificProduct == 1 ? 'mdi-check-circle-outline' :'mdi-close-circle'  }}</v-icon></td>
                                </tr>
                        </tbody>
                    </v-simple-table>
                </v-container>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'WhyNot',
    props: ['dataWhy','viewWhy'],
    data: function() {
        return  {

        }
    }
}
</script>